import { ShippingApi } from '../util/api';
import { showErrorToast } from '../util/toast';
import { fetchCurrentUser } from './user.duck';
import axios from 'axios';
// ================ Action types ================ //

export const FETCH_LISTINGS_IN_PROGRESS = 'app/shippo/FETCH_LISTINGS_IN_PROGRESS';
export const FETCH_LISTINGS_SUCCESS = 'app/shippo/FETCH_LISTINGS_SUCCESS';

export const SAVE_CONTACT_DETAILS_REQUEST = 'app/shippo/SAVE_CONTACT_DETAILS_REQUEST';
export const SAVE_CONTACT_DETAILS_SUCCESS = 'app/shippo/SAVE_CONTACT_DETAILS_SUCCESS';
export const SAVE_EMAIL_ERROR = 'app/shippo/SAVE_EMAIL_ERROR';
export const SAVE_PHONE_NUMBER_ERROR = 'app/shippo/SAVE_PHONE_NUMBER_ERROR';

export const SAVE_CONTACT_DETAILS_CLEAR = 'app/shippo/SAVE_CONTACT_DETAILS_CLEAR';

export const RESET_PASSWORD_REQUEST = 'app/shippo/RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'app/shippo/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'app/shippo/RESET_PASSWORD_ERROR';

export const CREATE_SHIPPO_ADDRESS_REQUEST = 'app/shippo/CREATE_SHIPPO_ADDRESS_REQUEST';
export const CREATE_SHIPPO_ADDRESS_SUCCESS = 'app/shippo/CREATE_SHIPPO_ADDRESS_SUCCESS';
export const CREATE_SHIPPO_ADDRESS_ERROR = 'app/shippo/CREATE_SHIPPO_ADDRESS_ERROR';

export const FETCH_REVERSE_GEOCODE_REQUEST = 'app/location/FETCH_REVERSE_GEOCODE_REQUEST';
export const FETCH_REVERSE_GEOCODE_SUCCESS = 'app/location/FETCH_REVERSE_GEOCODE_SUCCESS';
export const FETCH_REVERSE_GEOCODE_ERROR = 'app/location/FETCH_REVERSE_GEOCODE_ERROR';

export const SAVE_LISTINGS_RESPONSE = 'app/shippo/SAVE_LISTINGS_RESPONSE';
export const SAVE_WEIGHT_IN_PROGRESS = 'app/shippo/SAVE_WEIGHT_IN_PROGRESS';

export const CLEAR_REVERSE_GEOCODE_DATA = 'app/location/CLEAR_REVERSE_GEOCODE_DATA';
export const CLEAR_FORM = 'app/shippo/CLEAR_FORM';

// ================ Reducer ================ //

const initialState = {
  saveShippoAddressInProgress: false,
  shippoAddressSaved: false,
  saveShippoAddressError: null,
  clearForm: false,
  saveWeightInProgress: false,
  fetchListingsInProgress: false,
  listingsFetched: false,
  saveWeightInProgress: false,
  allListings: [],
  fetchReverseGeocodeInProgress: false,
  fetchReverseGeocodeError: null,
  userReverseGeocodeData: [],
  listingReverseGeocodeData: [],
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_LISTINGS_IN_PROGRESS:
      return {
        ...state,
        fetchListingsInProgress: true,
      };
    case FETCH_LISTINGS_SUCCESS:
      return { ...state, listingsFetched: false, fetchListingsInProgress: false };
    case CREATE_SHIPPO_ADDRESS_REQUEST:
      return {
        ...state,
        saveShippoAddressInProgress: true,
      };
    case CREATE_SHIPPO_ADDRESS_SUCCESS:
      return { ...state, saveShippoAddressInProgress: false, shippoAddressSaved: true };
    case CREATE_SHIPPO_ADDRESS_ERROR:
      return {
        ...state,
        saveShippoAddressInProgress: false,
        saveShippoAddressError: true,
      };
    case SAVE_LISTINGS_RESPONSE:
      return { ...state, allListings: payload.data };
    case CLEAR_FORM:
      return { ...state, clearForm: true };
    case SAVE_WEIGHT_IN_PROGRESS:
      return { ...state, saveWeightInProgress: true };
    case FETCH_REVERSE_GEOCODE_REQUEST:
      return {
        ...state,
        fetchReverseGeocodeInProgress: true,
        fetchReverseGeocodeError: null,
      };
    case FETCH_REVERSE_GEOCODE_SUCCESS:
      if (payload.originType === 'user') {
        return {
          ...state,
          fetchReverseGeocodeInProgress: false,
          userReverseGeocodeData: payload.data,
        };
      } else if (payload.originType === 'listing') {
        return {
          ...state,
          fetchReverseGeocodeInProgress: false,
          listingReverseGeocodeData: payload.data,
        };
      }
      return state;
    case FETCH_REVERSE_GEOCODE_ERROR:
      return {
        ...state,
        fetchReverseGeocodeInProgress: false,
        fetchReverseGeocodeError: payload,
        reverseGeocodeData: null,
      };
    case CLEAR_REVERSE_GEOCODE_DATA:
      return {
        ...state,
        userReverseGeocodeData: [],
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchListingsInProgress = () => ({ type: FETCH_LISTINGS_IN_PROGRESS });
export const fetchListingsSuccess = () => ({ type: FETCH_LISTINGS_SUCCESS });

export const createShippoAddressRequest = () => ({ type: CREATE_SHIPPO_ADDRESS_REQUEST });
export const createShippoAddressSuccess = () => ({ type: CREATE_SHIPPO_ADDRESS_SUCCESS });
export const createShippoAddressError = () => ({ type: CREATE_SHIPPO_ADDRESS_ERROR });
export const clearForm = () => ({ type: CLEAR_FORM });
export const saveWeightInProgress = () => ({ type: SAVE_WEIGHT_IN_PROGRESS });

export const saveListingsResponse = response => ({
  type: SAVE_LISTINGS_RESPONSE,
  payload: { data: response },
});

export const fetchGeocodeRequest = () => ({ type: FETCH_REVERSE_GEOCODE_REQUEST });
export const fetchGeocodeSuccess = ({ data, originType }) => ({
  type: FETCH_REVERSE_GEOCODE_SUCCESS,
  payload: { data, originType },
});
export const fetchGeocodeError = error => ({
  type: FETCH_REVERSE_GEOCODE_ERROR,
  payload: error,
  error: true,
});
export const clearReverseGeocodeData = () => ({
  type: CLEAR_REVERSE_GEOCODE_DATA,
});

// ================ Selectors ================ //
export const selectShippoAddressStatus = state => {
  return {
    saveShippoAddressInProgress: state?.shippo?.saveShippoAddressInProgress ?? false,
    saveShippoAddressError: state?.shippo?.saveShippoAddressError ?? null,
  };
};
// ================ Thunks ================ //

export const createShippoAddress = params => async (dispatch, getState, sdk) => {
  dispatch(createShippoAddressRequest());
  try {
    const address = Object.keys(params).length && (await ShippingApi.createShippoAddress(params));
    dispatch(createShippoAddressSuccess());
    return address;
  } catch (error) {
    dispatch(createShippoAddressError());
  }
};

export const fetchReverseGeocode = ({ longitude, latitude, originType }) => async (
  dispatch,
  _getState,
  sdk
) => {
  try {
    dispatch(fetchGeocodeRequest());
    const response = await axios.get(
      `${process.env.REACT_APP_MAPBOX_GEOCODE_API_URL}/search/geocode/v6/reverse?longitude=${longitude}&latitude=${latitude}&limit=1&access_token=${process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}`
    );

    dispatch(fetchGeocodeSuccess({ data: response.data, originType }));
    return response.data;
  } catch (error) {
    showErrorToast(error, 'Something went wrong while fetching error. Please try again later.');
  }
};

export const loadData = () => {
  return fetchCurrentUser();
};
